import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { SubmissionError, reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import { authenticate } from '../../service';
import { required, email } from '../../validators';
import { login } from '../../actions';

class Login extends Component {
  onSubmit = async values => {
    let result;

    try {
      result = await authenticate(values);
    } catch (ex) {
      // eslint-disable-next-line no-alert
      alert(ex.message);
      return;
    }

    if (result.response.errors) {
      throw new SubmissionError(result.response.errors);
    } else {
      this.props.authSuccess(result.response.user.authentication_token);
      this.props.history.push('/');
    }
  };

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div>
        <Paper style={{ padding: 20 }}>
          <form onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              name="email"
              component={TextField}
              hintText="Email"
              disabled={submitting}
              validate={[required, email]}
            />
            <br />
            <Field
              name="password"
              type="password"
              component={TextField}
              validate={[required]}
              disabled={submitting}
              hintText="Password"
            />
            <br />
            <RaisedButton
              onClick={handleSubmit(this.onSubmit)}
              label="Login"
              style={{ margin: 12 }}
              disabled={submitting}
            />
          </form>
        </Paper>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    authSuccess: token => {
      dispatch(login(token));
    },
  };
}

export default connect(null, mapDispatchToProps)(
  reduxForm({
    form: 'loginForm',
  })(Login)
);



// WEBPACK FOOTER //
// ./src/components/login/Login.js